// Static content for The Aesthetics Academy Co
import { QUALIFI_AESTHETICS, QUALIFI_EDUCATION } from "./qualifi";
import { CPD_COURSES } from "./cpd";

export const IMAGES = {
  heroModel:
    "https://images.pexels.com/photos/3985360/pexels-photo-3985360.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1600",
  salon:
    "https://images.pexels.com/photos/13068377/pexels-photo-13068377.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  treatment:
    "https://images.pexels.com/photos/3762453/pexels-photo-3762453.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  charlotte: "/charlotte.jpg",
  edwina: "/edwina.jpg",
  // Elegant, editorial payment image: gold-tone jewellery / stationery still-life
  payment:
    "https://images.unsplash.com/photo-1607083206968-13611e3d76db?auto=format&fit=crop&q=85&w=1400",
  aestheticsCard:
    "https://images.pexels.com/photos/3985338/pexels-photo-3985338.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  educationCard:
    "https://images.pexels.com/photos/5905492/pexels-photo-5905492.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
};

export const FEATURES = [
  { title: "Expert Training", text: "High-quality education delivered by experienced aesthetics practitioners and educators.", icon: "UserCircle" },
  { title: "Hands On Experience", text: "Practical learning with real models in a supportive, professional environment.", icon: "MonitorCheck" },
  { title: "Small Class Sizes", text: "Focused attention to help you build confidence and develop your practical skills.", icon: "Users" },
  { title: "Ongoing Support", text: "We're with you every step of the way, even after your training is complete.", icon: "Headphones" },
];

// Programme areas linked to the two detailed Qualifi pages and the CPD catalogue.
export const PROGRAMMES = [
  {
    id: "aesthetics",
    name: "Qualifi Aesthetics",
    tagline: "Level 3  ·  Level 4  ·  Level 5  ·  Level 7",
    blurb:
      "Regulated qualifications supporting progression in clinical aesthetics, from Basic Life Support and Anaphylaxis Management through to advanced aesthetic practice.",
    image:
      "https://images.pexels.com/photos/3985338/pexels-photo-3985338.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    path: "/courses/aesthetics",
    count: QUALIFI_AESTHETICS.length,
    label: "Ofqual Regulated",
    ctaLabel: (n) => `View ${n} Qualifications`,
  },
  {
    id: "education",
    name: "Qualifi Education",
    tagline: "AET  ·  CAVA  ·  IQA  ·  DET",
    blurb:
      "Regulated qualifications in teaching, assessment and internal quality assurance for practitioners developing or progressing within education.",
    image:
      "https://images.pexels.com/photos/5905492/pexels-photo-5905492.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    path: "/courses/education",
    count: QUALIFI_EDUCATION.length,
    label: "Ofqual Regulated",
    ctaLabel: (n) => `View ${n} Qualifications`,
  },
  {
    id: "cpd",
    name: "Accredited CPD Training",
    tagline: "Microneedling  ·  Fillers  ·  Anti-Wrinkle  ·  More",
    blurb:
      "19 accredited CPD training courses, from Microneedling and Dermaplaning to Advanced Injectables, combining essential theory with hands-on practical training.",
    image:
      "https://images.pexels.com/photos/3762879/pexels-photo-3762879.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    path: "/courses/cpd",
    count: 19,
    label: "Accredited CPD",
    ctaLabel: () => "View CPD Courses",
  },
];

// Category groups for enquiry / contact form dropdowns.
export const COURSE_CATEGORIES = [
  {
    id: "cpd",
    name: "Accredited CPD Training",
    options: CPD_COURSES.map((c) => ({ id: c.id, name: c.name })),
  },
  {
    id: "aesthetics",
    name: "Aesthetics Qualifications",
    options: QUALIFI_AESTHETICS.map((q) => ({ id: q.id, name: q.title })),
  },
  {
    id: "education",
    name: "Education & Training Qualifications",
    options: QUALIFI_EDUCATION.map((q) => ({ id: q.id, name: q.title })),
  },
  {
    id: "advice",
    name: "Not sure, I'd like some advice",
    options: [],
  },
];

// Legacy flat list retained for other consumers.
export const COURSE_OPTIONS = COURSE_CATEGORIES.flatMap((cat) => cat.options);

export const PAYMENT_METHODS = [
  { name: "Card Payment",   text: "We accept all major debit and credit cards for your convenience.", icon: "CreditCard" },
  { name: "Bank Transfer",  text: "Payment can be made securely by bank transfer. Please contact our team for payment details and include your name and course reference when making payment.", icon: "Landmark" },
  { name: "Klarna",         text: "Flexible payment options with Klarna. Pay in 3 or pay later.", icon: "Wallet" },
  { name: "Clearpay",       text: "Spread the cost with Clearpay. Pay in 4 interest-free payments.", icon: "Layers" },
  { name: "Pay It Later",   text: "Flexible finance options through Pay It Later.", icon: "CalendarClock" },
  { name: "Cash Payment",   text: "Cash payment is available for those who prefer to pay for their training in full. Please contact our team to arrange payment.", icon: "Banknote" },
];

export const TRAINERS = [
  {
    name: "Charlotte Thompson",
    title: "Advanced Aesthetics Practitioner & Educator",
    subtitle: "Founder of CLouise Aesthetics",
    phone: "07864 259 007",
    image: IMAGES.charlotte,
    bio: [
      "I'm Charlotte, an Advanced Aesthetics Practitioner and Educator.",
      "Having built my own successful aesthetics business from the ground up, I understand first-hand both the rewards and the challenges of working within this industry. Having started exactly where many of my students are today, I know how important it is to have the right guidance, encouragement and ongoing support throughout your journey. That understanding is one of the biggest reasons I became an educator.",
      "My passion for aesthetics extends far beyond delivering treatments. I genuinely love helping others develop the confidence, practical skills and knowledge needed to build successful, sustainable careers of their own.",
      "Throughout my career, I have remained committed to continually developing my own education and clinical practice, allowing me to deliver safe, high-quality treatments while staying up to date with the latest techniques and industry standards. As an educator, my aim is to pass that knowledge on in a way that is supportive, approachable and easy to understand.",
      "I believe exceptional training is about so much more than gaining a qualification. It's about giving every learner the confidence to treat safely, communicate professionally and leave with the practical skills they need to succeed in the real world.",
      "Watching my students progress, develop their abilities and build businesses they're proud of is one of the most rewarding parts of my career. My goal isn't just to teach treatments, it's to help people believe in their abilities, continue developing their skills and build a career they can truly be proud of.",
    ],
  },
  {
    name: "Edwina Evans",
    title: "Advanced Aesthetics Practitioner, Educator & Assessor",
    subtitle: "Founder of Bonds Aesthetics & The Aesthetics Academy Co.",
    phone: "07354 731 402",
    image: IMAGES.edwina,
    bio: [
      "I'm Edwina, an Advanced Aesthetics Practitioner, Educator and Assessor.",
      "With extensive experience in advanced aesthetics, skin health and professional education, I am passionate about helping aspiring and experienced practitioners develop the knowledge, practical skills and confidence needed to build successful careers within the aesthetics industry.",
      "My teaching combines evidence-based theory with hands-on practical training, ensuring every learner gains a thorough understanding of both the science and practical application behind each treatment. I believe education should go beyond simply learning a technique, it should develop competent, ethical and confident practitioners who prioritise client safety and achieve consistently high standards.",
      "As an educator and assessor, I am committed to raising standards within the aesthetics industry through high-quality education, ongoing professional development and a strong emphasis on safe, evidence-informed practice. Every course has been designed to provide a supportive learning environment where learners receive individual guidance, practical experience and the confidence to progress within their careers.",
      "Whether you're taking your first step into aesthetics or expanding your existing treatment portfolio, my goal is to provide an enjoyable, professional learning experience that equips you with the skills, knowledge and support to succeed.",
    ],
  },
];

// Kept for future reinstatement, currently hidden from Home page.
export const TESTIMONIALS = [];

export const CONTACT = {
  email: "theaestheticsacademyco@gmail.com",
  phone: "07354 731 402",
  location: "Sutton Coldfield",
  instagram: "https://www.instagram.com/theaestheticsacademy.co",
  companyName: "Bonds Aesthetics Ltd",
  tradingAs: "The Aesthetics Academy Co.",
  companyNumber: "13045646",
  registeredOffice: "264 Lichfield Road, Sutton Coldfield, B74 2UH",
};
